module.exports = __webpack_public_path__ + "img/timer.107457fe.svg";